import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function usePageMeta({ title, description, ogTitle, ogDescription }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const setMeta = (selector, content) => {
      let el = document.querySelector(selector);
      if (!el) {
        const [attr, value] = selector.includes("property=")
          ? ["property", selector.match(/property="([^"]+)"/)[1]]
          : ["name", selector.match(/name="([^"]+)"/)[1]];
        el = document.createElement("meta");
        el.setAttribute(attr, value);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta('meta[name="description"]', description);
    }
    if (ogTitle) {
      setMeta('meta[property="og:title"]', ogTitle);
    }
    if (ogDescription) {
      setMeta('meta[property="og:description"]', ogDescription);
    }

    const canonicalUrl = `${window.location.origin}${pathname}`;
    setMeta('meta[property="og:url"]', canonicalUrl);

    setMeta(
      'meta[property="og:image"]',
      "https://customer-assets.emergentagent.com/job_shivani-studio/artifacts/5zw1i64b_ChatGPT%20Image%20May%2023%2C%202026%2C%2004_55_42%20PM.png"
    );
  }, [title, description, ogTitle, ogDescription, pathname]);
}
